<template>
    <section class="app-main">
        <div class="top-bar">
            <el-input placeholder="输入手机号码或邮箱" v-model="searchVal" @change=" page=1; getData();" style="width:240px;" clearable>
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
        </div>
        <el-card >
            <el-table :data="tableData"  height="580">
                <el-table-column prop="username" label="昵称" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.username">{{scope.row.username}}</span>
                        <span v-else>--</span>
                    </template>
                </el-table-column>
                <el-table-column prop="phone" label="手机号"  align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.phone">{{scope.row.phone}}</span>
                        <span v-else>--</span>
                    </template>
                </el-table-column>
                <el-table-column prop="email" label="邮箱"  align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.email">{{scope.row.email}}</span>
                        <span v-else>--</span>
                    </template>
                </el-table-column>
                <el-table-column prop="amount" label="活动钱包余额"  align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.amount">{{scope.row.amount}}</span>
                        <span v-else>--</span>
                    </template>
                </el-table-column>
                <el-table-column label="编辑" align="center" width="285">
                    <template slot-scope="scope">
                        <el-button type="primary" plain size="mini"  @click="goDetail(scope.row)">详情</el-button>
                        <el-button type="success" plain size="mini"  @click="handleShow(scope.row)">余额储值</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background @current-change="reloadData" layout="prev, pager, next, jumper" style="padding:15px" :total="total" :page-size="size"></el-pagination>
        </el-card>
        <!-- 添加 | 修改 弹出框 -->
        <el-dialog :visible.sync="dialog" :title="dialogTitle"  width="600px" align="center">
           <el-row class="line-item">
               <el-col :span="4" class="item-label">储值金额：</el-col>
               <el-col :span="20">
                   <el-input placeholder="请输入储值金额" v-model="amount"></el-input>
               </el-col>
           </el-row>
           <el-row class="line-item">
               <el-col :span="4" class="item-label">执行密码：</el-col>
               <el-col :span="20">
                   <el-input placeholder="请输入执行密码" v-model="password"></el-input>
               </el-col>
           </el-row>
           <el-row type="flex" class="line-item" justify="center">
                <el-col :span="6" style="text-align:center"><el-button :disabled="disabled" type="info" plain @click="dialog = false" style="width:120px">取消</el-button></el-col>
                <el-col :span="6" style="text-align:center"><el-button :disabled="disabled" type="primary" plain @click="handleBtn" style="width:120px">确定</el-button></el-col>
            </el-row>
        </el-dialog>


       <el-dialog :visible.sync="dialog2" :title="dialogTitle2"  width="1300px" align="center">
            <el-table :data="tableData2"  height="580">
                <el-table-column prop="phone" label="手机号"  align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.phone">{{scope.row.phone}}</span>
                        <span v-else>--</span>
                    </template>
                </el-table-column>
                <el-table-column prop="email" label="邮箱"  align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.email">{{scope.row.email}}</span>
                        <span v-else>--</span>
                    </template>
                </el-table-column>
                <el-table-column prop="amount" label="储值金额"  align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.amount">{{scope.row.amount}}</span>
                        <span v-else>--</span>
                    </template>
                </el-table-column>
                <el-table-column prop="manager_account" label="操作人"  align="center"></el-table-column>
                <el-table-column prop="created_at" label="储值时间"  align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.created_at">{{scope.row.created_at}}</span>
                        <span v-else>--</span>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background @current-change="reloadData2" layout="prev, pager, next, jumper" style="padding:15px" :total="total2" :page-size="size2"></el-pagination>
        </el-dialog>
    </section>
</template>
<script>
//eslint-disable-next-line no-unused-vars
import {  wallet_list, wallet_recharge, wallet_recharge_log  } from '@/api/market.js'
export default {
    data() {
        return {
            searchVal: '',
            tableData:[],
            tableData2:[],
            table_load:false,
            total:0,
            total2:0,
            page: 1,
            page1: 1,
            size: 0,
            size2: 0,
            dialog:false,    // 控制显示 添加修改弹窗
            dialog2:false,    // 控制显示 添加修改弹窗
            dialogTitle2:'活动余额储值记录',
            dialogTitle:'活动余额储值',
            amount:'',
            password:'',
            disabled: false,
            row: {},
        }
    },
    methods: {
        getData() {
            let params = {
                page:this.page,
            }
            if(this.searchVal != '') {
                params.keywords = this.searchVal
            }
            wallet_list(params).then(res => {
                if(res) {
                    this.tableData = res.data.data
                    this.total = res.data.total
                    this.size  = res.data.per_page
                } else {
                    this.tableData = []
                }
            })
        },
        reloadData(page) {
            this.page = page;
            this.getData();
        },
        reloadData2(page) {
            this.page1 = page;
            this.goDetail(this.row);
        },
        // 显示 添加 弹窗
        handleShow(row) {
            if(row?.user_id) {
                this.row = row
            }
            this.dialog = true
        },
        // 弹窗里面 点击确定
        handleBtn() {
            this.handleAdd()
        },
        // 添加 活动
        handleAdd() {
            if(this.amount == "") {
                this.$message.error("请输入储值金额!")
                return false
            }
            if(this.password == "") {
                this.$message.error("请输入执行密码!")
                return false
            }
            let params = {
                user_id: this.row.user_id,
                amount: this.amount,
                password: this.password,
            }
            this.disabled = true
            wallet_recharge(params).then(res => {
                if(res) {
                    this.$message({message:res.msg,type:'success'})
                    this.getData()
                    this.dialog   = false
                }
            }).finally( () => {
                this.password = "";
                this.disabled = false
            })
        },
        // 显示 添加 弹窗
        getRechargeLog(row) {
            let params = {
                keywords: row.phone?row.phone:row.email,
                page: this.page1
            }
            wallet_recharge_log(params).then(res => {
                if(res) {
                    this.tableData2 = res.data.data
                    this.total2 = res.data.total
                    this.size2  = res.data.per_page
                } else {
                    this.tableData2 = []
                }
            })
        },
        // 跳转活动详情
        async goDetail(row) {
            if(row?.user_id) {
                this.row = row
            }
            await this.getRechargeLog(row)
            this.dialog2 = true
        },
    },
    created(){
        this.getData()
    },
    activated() {
        this.getData()
    },
}
</script>

<style lang="less" scoped>
section {
    .item-label {
        height: 40px;
        line-height: 40px;
    }
    .line-item {
        margin-top: 25px;
        &:nth-child(1){
            margin-top: 0;
        }
    }
}
</style>
